export default __webpack_public_path__ + "static/media/user.a1396fa2.svg";